import api from './api';

export const registrationApi = api.injectEndpoints({
  endpoints: builder => ({
    createStudent: builder.mutation({
      query: payload => ({
        url: '/api/studentlead/create',
        method: 'POST',
        body: payload
      })
    }),
    fetchStudents: builder.query({
      query: () => ({
        url: '/api/studentlead/getall',
        method: 'GET'
      })
    })
  })
});

export const { useCreateStudentMutation, useFetchStudentsQuery } =
  registrationApi;
